<template>
	<div class="layout-menu-container">
		<FrameSubmenu :items="model" class="layout-menu" :root="true" @menuitem-click="onMenuItemClick" />
	</div>
</template>

<script>
import FrameSubmenu from './FrameSubmenu';

export default {
	props: {
		model: Array
	},
    methods: {
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
        }
    },
	components: {
		'FrameSubmenu': FrameSubmenu
	}
}
</script>

<style scoped>

</style>
